import ModalType from '@/Enums/Pixels/ModalType.enum';
import { ISegmentControlOption } from '@/Interfaces/ControlOption.interface';
import { IPixelsFilterModel } from '@/Interfaces/Filters/FilterModel.interface';
import { IPixelFormData } from '@/Interfaces/Pixels/Pixel.interface';

export const MODAL_TITLES: Record<ModalType, string> = {
  [ModalType.NewPixel]: 'Create New Pixel',
  [ModalType.ViewPixel]: 'View Pixel',
};

export const SUBMIT_BUTTON_TITLES: Record<ModalType, string> = {
  [ModalType.NewPixel]: 'Generate Tag & Save',
  [ModalType.ViewPixel]: 'Save',
};

export const DEFAULT_PIXEL: IPixelFormData = {
  name: '',
  advertiser: null,
  segment: null,
  clickWindow: '30',
  viewWindow: '30',

  newSegment: '',
  segmentLocked: false,
};

export const DEFAULT_FILTERS: IPixelsFilterModel = {
  whitelabels: [],
  clients: [],
  advertisers: [],
  status: [],
  active: true,
};

export const DEFAULT_PIXELS_FIRED_BY_DAY = Array.from({ length: 7 }, () => ({ value: 0, date: '' }));

export const NEW_SEGMENT_OPTION: Partial<ISegmentControlOption> = {
  label: 'CREATE NEW',
  isCreateNewOption: true,
};
